module.exports = __webpack_public_path__ + "static/hell-step2-f48a5aeaac68d519536d282fb04f5c87.png";